module.exports = __webpack_public_path__ + "img/e2a8883.jpg";